import { color } from "minimum-ui/tokens";
import { rem } from "polished";
import styled, { css } from "styled-components";

const Cell = styled.div<{
  $sticky?: boolean;
  $stickyOffset?: number;
  $right?: boolean;
  colSpan?: number;
}>`
  display: flex;
  padding: 16px 24px;
  font-size: ${rem(14)};
  line-height: ${rem(20)};
  color: ${color.neutral[400]};
  align-items: center;
  border-bottom: 1px solid ${color.neutral[200]};

  ${(props) =>
    props.colSpan &&
    css`
      grid-column: span ${props.colSpan};
    `}

  ${(props) =>
    props.$sticky &&
    css`
      background: ${color.basic.white};
      border-left: 1px solid ${color.neutral[200]};
      position: sticky;
      right: 0;
      box-shadow: -5px 0 10px -1px ${color.neutral[200]};
    `}

    ${(props) =>
    props.$stickyOffset &&
    css`
      right: ${props.$stickyOffset}px;
    `}

  ${(props) =>
    props.$right &&
    css`
      text-align: right;
      justify-content: flex-end;
    `}
`;

export const CondensedCell = styled(Cell)`
  padding: 12px 24px;
  background-color: ${color.basic.white};
`;

export const FooterCell = styled(CondensedCell)<{
  $sticky?: boolean;
  $stickyOffset?: number;
  $noShadow?: boolean;
}>`
  background-color: ${color.neutral[100]};
  border-top: 1px solid ${color.neutral[300]};
  position: sticky;
  bottom: 0;

  ${(props) =>
    props.$sticky &&
    css`
      background-color: ${color.neutral[100]};
      border-left: 1px solid ${color.neutral[200]};
      position: sticky;
      right: 0;
      box-shadow: -5px 0 10px -1px ${color.neutral[300]};
    `}

  ${(props) =>
    props.$stickyOffset &&
    css`
      right: ${props.$stickyOffset}px;
    `}

    ${(props) =>
    props.$noShadow &&
    css`
      box-shadow: none;
    `}
`;

export default Cell;
